<template>
    <div class="container-fluid">
        <div v-if="tagTemplate">
            <div class="row">
                <div class="col-md-8">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <input-field :editable="editMode" label="Name" type="text"
                                        v-model="tagTemplate.name" />
                                </div>
                                <div v-if="this.$store.getters.userRoles.isAqferAdmin || this.$store.getters.userRoles.isAqferManager" class="col-md-3">
                                    <input-field :editable="editMode" label="Make Public" type="checkbox"
                                        v-model="tagTemplate.public" />
                                    <input-field v-if="showRecommended" :editable="editMode" label="Recommended" type="checkbox"
                                        v-model="tagTemplate.recommended" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <input-field :editable="editMode" label="Event Type" :options="eventTypeOptions"
                                        type="select" v-model="tagTemplate.event_type" />
                                </div>
                                <div class="col-md-3">
                                    <input-field :editable="editMode" label="Sub Event Type 1" :options="subEvent1Options" placeholder="Enter/Select"
                                        type="customSingleSelect" v-model="tagTemplate.sub_event_type_1" />
                                </div>
                                <div v-if="tagTemplate.sub_event_type_1" class="col-md-3">
                                    <input-field :editable="editMode" label="Sub Event Type 2" :options="subEvent2Options" placeholder="Enter/Select"
                                        type="customSingleSelect" v-model="tagTemplate.sub_event_type_2" />
                                </div>
                                <div class="col">
                                    <input-field :editable="editMode" label="Initiator (optional)" placeholder="Search initiators..."
                                        :options="initiatorOptions" type="customSingleSelect" :createOption="false" v-model="tagTemplate.initiator" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <input-field :editable="editMode" label="Delivery Type" :options="deliveryOptions"
                                        type="select" v-model="deliveryType" />
                                </div>
                                <div class="col" v-if="deliveryType == 'atomic'">
                                    <input-field :editable="editMode" label="Atomic Type" :options="atomicOptions"
                                        type="select" v-model="atomicType" />
                                </div>
                                <div class="col" v-if="
                                    deliveryType != 'atomic' ||
                                    atomicType != 'r'
                                ">
                                    <input-field :editable="editMode" label="Extra Logic" :options="logicOptions"
                                        type="select" v-model="logicType" />
                                </div>
                                <div class="col">
                                    <input-field :editable="false" label="Tag Type" :options="tagTypeOptions"
                                        type="select" v-model="tagTemplate.tag_type" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <input-field :editable="editMode" label="Log Delivery" :options="logDeliveryOptions"
                                        type="select" v-model="logDelivery" />
                                </div>
                                <div class="col">
                                    <input-field :editable="editMode" label="Log Size" :options="logSizeOptions"
                                        type="select" v-model="logSize" />
                                </div>
                                <div class="col">
                                    <input-field :editable="editMode" label="Log IP type" :options="logIPTypeOptions"
                                        type="select" v-model="logIPType" />
                                </div>
                                <div class="col">
                                    <input-field :editable="false" label="Logging Mode" :options="loggingModeOptions"
                                        type="select" v-model="tagTemplate.logging_mode" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <input-field :editable="editMode" label="Category Tags" :options="tagTemplate.tag"
                                        type="multiselect" v-model="tagTemplate.tag" />
                                </div>
                                <div class="col-md-3 checkbox-center">
                                    <input-field :editable="editMode" label="Measurement Tag" type="checkbox"
                                        v-model="tagTemplate.measurement_tag" />
                                </div>
                            </div>

                            <div class="row initiator-fields-div" v-if="tagTemplate.initiator">
                                <div class="col">
                                    <h3>Initiator Fields
                                        <span v-if="initiator && initiator.name">(
                                            <a v-if="initiator.url && initiator.url!==''" 
                                                :href="initiator.url" target="_blank" 
                                                class="card-link link-primary"
                                                data-bs-placement="right">{{initiator.label}}</a>
                                            <label v-else >{{ initiator.label }}</label>
                                        )</span>
                                    </h3>
                                    <table class="table table-sm table-nowrap">
                                        <thead>
                                            <tr>
                                                <th scope="col">Name</th>
                                                <th scope="col">Parameter</th>
                                                <th scope="col">Input/Macro</th>
                                                <th scope="col">Metadata<span class="fa fa-circle-info text-muted mx-1" title="JSON stored with the template, eg {&quot;category&quot;:&quot;CPL&quot;}" data-bs-toggle="tooltip" data-bs-placement="top"></span></th>
                                                <th scope="col">Omit<span class="fa fa-circle-info text-muted mx-1" title="Leave this field out of the tag generated below. Not saved with the template." data-bs-toggle="tooltip" data-bs-placement="top"></span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="field in initiatorFields" :key="field.name">
                                                <td>{{ field.name }}<span   v-if="field.description" class="fa fa-circle-info mx-1 text-muted" :data-bs-title="field.description"  data-bs-toggle="tooltip" data-bs-placement="top" data-bs-container="table" data-bs-html="true"></span><span v-if="field.cid" class="badge bg-light text-muted mx-1">{{ field.cid }}</span></td>
                                                <td>{{ field.parameter }}</td>
                                                <td>{{ field.input }}</td>
                                                <td>
                                                    <div v-if="!editMode">{{ metaText(initiatorFieldMeta(field.name)) }}</div>
                                                    <div v-else>
                                                        <input style="padding: 1px 2px;" class="form-control"
                                                            :class="{ 'is-invalid': metaErrors[field.name] }"
                                                            type="text" placeholder="{}"
                                                            :value="metaDrafts[field.name] !== undefined ? metaDrafts[field.name] : metaText(initiatorFieldMeta(field.name))"
                                                            @input="onInitiatorFieldMetaInput(field, $event.target.value)" />
                                                        <div v-if="metaErrors[field.name]" class="invalid-feedback d-block">{{ metaErrors[field.name] }}</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <input type="checkbox" v-model="omittedFields[field.name]" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <h3>User Defined Fields</h3>
                                    <table class="table table-sm table-nowrap">
                                        <thead>
                                            <tr>
                                                <th scope="col">Name</th>
                                                <th scope="col">Parameter</th>
                                                <th scope="col">Input/Macro<span class="fa fa-circle-info text-muted" title="use !var: for no quotes, eg: !var:document.var" data-bs-toggle="tooltip" data-bs-placement="right"></span></th>
                                                <th scope="col">Metadata<span class="fa fa-circle-info text-muted mx-1" title="JSON stored with the field, eg {&quot;category&quot;:&quot;CPA&quot;}" data-bs-toggle="tooltip" data-bs-placement="top"></span></th>
                                                <th v-if="editMode" scope="col">Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(
                                                    field, index
                                                ) in tagTemplate.user_defined_fields" :key="index">
                                                <td>{{ field.name }}</td>
                                                <td>
                                                    <div v-if="field.name =='Custom' && editMode">
                                                        <input style="padding: 1px 2px;" 
                                                                class="form-control" type="text" 
                                                                v-model="tagTemplate.user_defined_fields[index].parameter"
                                                        />
                                                    </div>
                                                    <div v-else>
                                                        {{ field.parameter }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="!editMode">
                                                        {{ field.input }}
                                                    </div>
                                                    <div v-else>
                                                        <input style="padding: 1px 2px;"
                                                            class="form-control" type="text" v-model="tagTemplate.user_defined_fields[index].input" />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="!editMode">{{ metaText(field.meta_data) }}</div>
                                                    <div v-else>
                                                        <input style="padding: 1px 2px;" class="form-control"
                                                            :class="{ 'is-invalid': metaErrors[userDefinedMetaKey(index)] }"
                                                            type="text" placeholder="{}"
                                                            :value="metaDrafts[userDefinedMetaKey(index)] !== undefined ? metaDrafts[userDefinedMetaKey(index)] : metaText(field.meta_data)"
                                                            @input="onUserDefinedFieldMetaInput(index, $event.target.value)" />
                                                        <div v-if="metaErrors[userDefinedMetaKey(index)]" class="invalid-feedback d-block">{{ metaErrors[userDefinedMetaKey(index)] }}</div>
                                                    </div>
                                                </td>
                                                <td v-if="editMode">
                                                    <i @click="removeUserDefinedField(index)" class="fa fa-regular fa-trash-can"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="row" v-if="editMode">
                                        <div class="col9">
                                            <input-field :editable="editMode" placeholder="Please select"
                                                label="Add User Defined Field" :options="userDefinedFieldOptions"
                                                type="select" v-model="userDefinedFieldAddon" />
                                        </div>
                                        <div class="col-md-4 mb-3">
                                                <button class="btn btn-primary" @click="onCustomAdd">Add Custom Field</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="tagTemplate.notes || editMode">
                                <div class="col">
                                    <h3>Notes</h3>
                                    <WYSIWYG v-if="editMode" v-model="tagTemplate.notes" />
                                    <div v-else v-html="tagTemplate.notes"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">

                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-header-title">Generate Tag</h3>
                        </div>
                        <div class="card-body">

                            <input-field label="Choose Domain" :validate="[{ type: 'required' }]"
                                :options="domainOptions" type="select" v-model="tagDomain" />

                            <input-field label="Choose Class" :options="classOptions" type="select"
                                v-model="tagClass" />

                            <input-field v-if="safariItpApplies" label="Client Website Domain" type="text"
                                placeholder="ex: www.example.com" :validate="[{ type: 'required' }]"
                                toolTip="Your own website domain that proxies through to aUT. Safari and iOS traffic is served from this domain instead of the aUT domain, so Safari does not truncate the aUT cookie."
                                v-model="safariItpClientDomain" />

                            <input-field v-if="safariItpApplies" label="Path Prefix" type="text"
                                placeholder="ex: /proxy" :validate="[{ type: 'required' }]"
                                toolTip="Path prefix prepended to the aUT request path on your website domain."
                                v-model="safariItpPathPrefix" />

                            <input-field v-if="this.tagTemplate.tag_type == 'r'" label="Redirect URL" type="text"
                                v-model="redirectTarget" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <button v-if="!safariItpIncomplete" class="btn btn-primary float-end mb-2"
                                @click="copyMinified()">
                                Copy Minified Code
                            </button>
                        </div>
                    </div>
                    <div class="card">
                        <div v-if="safariItpIncomplete" class="card-footer rounded-3 text-muted">
                            Enter the Client Website Domain and Path Prefix to generate the tag for
                            <strong>{{ tagDomain }}</strong>. Safari and iOS traffic is routed through
                            your own website domain, so the tag cannot be generated without them.
                        </div>
                        <div v-else class="card-footer rounded-3 bg-dark">
                            <code class="html bg-dark xml">
                                {{ generatedCode }}
                            </code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import InputField from "../../components/InputField.vue";
import WYSIWYG from "../../components/WYSIWYG.vue";
import { tag_event_types } from "../../utils/constOptionValues";
import { isProxyEnabledDomain, safariItpTagParts } from "../../utils/safariItp";

const LOG_KEYS = {
    b: "bbh",
    c: "bbi",
    d: "beh",
    e: "bei",
    f: "sbh",
    g: "sbi",
    h: "seh",
    i: "sei",
    j: "bbn",
    k: "ben",
    l: "sbn",
    m: "sen",
};

const escapeTagComponent = (value) =>
    encodeURIComponent(String(value)).replace(
        /[!'()*]/g,
        (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase()
    );

const encodeTagParamName = (name) => escapeTagComponent(name);

// Field values escape only the characters that break a query value, the wrapper's
// '...' JS string or an HTML attribute. Macro syntax such as %eaid!, [timestamp],
// ${X} or @@X@@ passes through so partner find/replace still matches. Mirrors
// Surface's generate=1.
const FIELD_VALUE_ESCAPES = {
    " ": "%20", "&": "%26", "#": "%23", "+": "%2B", ";": "%3B",
    '"': "%22", "'": "%27", "<": "%3C", ">": "%3E", "\\": "%5C",
    "\n": "%0A", "\r": "%0D", "\t": "%09",
};

const encodeFieldValue = (value) =>
    String(value).replace(/[ &#+;"'<>\\\n\r\t]/g, (c) => FIELD_VALUE_ESCAPES[c]);

const USER_DEFINED_FIELD_KEYS = {
    dmn: "Publisher Domain",
    pubid: "Publisher ID",
    uu: "Unique User ID",
    suu: "Statistical Unique User ID",
    payload: "Payload",
    evid: "Event ID",
    v0: "User Defined(0)",
    v1: "User Defined(1)",
    v2: "User Defined(2)",
    v3: "User Defined(3)",
    v4: "User Defined(4)",
    v5: "User Defined(5)",
    v6: "User Defined(6)",
    v7: "User Defined(7)",
    v8: "User Defined(8)",
    v9: "User Defined(9)",
};

export default {
    name: "TagTemplate",
    components: { InputField, WYSIWYG },
    data() {
        return {
            error: "",
            tagClass: "",
            tagDomain: "",
            logDelivery: "",
            logSize: "",
            logIPType: "",
            deliveryType: "",
            atomicType: "",
            logicType: "",
            pendingInitiatorFields: [],
            pendingInitiatorFieldsFor: "",
            resolvedInitiator: null,
            omittedFields: {},
            metaDrafts: {},
            metaErrors: {},
            userDefinedFieldAddon: "",
            redirectTarget: "",
            safariItpClientDomain: "",
            safariItpPathPrefix: "",
            label: this.$store.state.aut.autClientData.label,
            subEvent1Options:[],
            subEvent2Options:[]
        };
    },
    props: {
        modelValue: Object,
        editMode: Boolean
    },
    watch: {
        loggingMode(value, oldValue) {
            this.tagTemplate.logging_mode = value;
        },
        deliveryType() {
            this.updateTagTypeField()
        },
        /**
         * A stale client domain left behind by an earlier selection would otherwise end
         * up in the generated tag, so switching to a domain without proxy support
         * clears both Safari ITP values.
         */
        tagDomain() {
            this.clearSafariItpIfUnused();
        },
        "tagTemplate.tag_type"() {
            this.clearSafariItpIfUnused();
        },
        logicType() {
            this.updateTagTypeField()
        },
        atomicType() {
            this.updateTagTypeField()
        },
        "tagTemplate.initiator"(value, oldValue) {
            if (oldValue) {
                this.tagTemplate.metadata = {};
                this.metaDrafts = {};
                this.metaErrors = {};
            }
            this.omittedFields = {};
            this.pendingInitiatorFields = [];
            this.pendingInitiatorFieldsFor = "";
            this.getInitiatorFields();
        },
        userDefinedFieldAddon(value, oldValue) {
            if(value=="Custom"){
                this.tagTemplate.user_defined_fields.push({
                    name: "Custom",
                    parameter: "",
                    input: ""
                })
                this.userDefinedFieldAddon = "";
            } else if (value) {
                this.tagTemplate.user_defined_fields.push({
                    name: USER_DEFINED_FIELD_KEYS[value],
                    parameter: value,
                    input: ""
                })
                this.userDefinedFieldAddon = "";
            }
         },
        tagTemplate(value) {
            this.$emit("setTagTemplate", value);
        },
        "tagTemplate.event_type": {
            handler: function(newVal,oldValue) {
               this.onEventChange(newVal,oldValue);
            }
        },
        "tagTemplate.sub_event_type_1": {
            handler: function(newVal,oldValue) { 
                this.onSubEvent1Change(newVal);                                             
                this.tagTemplate.sub_event_type_2=''
            }
        },
        "tagTemplate.public":{
            handler: function(newVal){
                if(!newVal){
                    this.showRecommended = false;
                }
            }
        }
    },
    computed: {
        ...mapState({
            cid: (state) => state.currentClient.cid,
            domainList: (state) => state.aut.domainList,
        }),
        tagTemplate() {
            return this.modelValue;
        },
        initiatorFields() {
            const initiator = this.tagTemplate.initiator;
            if (!initiator) return [];
            if (initiator === this.resolvedInitiator) {
                return this.tagTemplate.initiator_fields || [];
            }
            if (initiator === this.pendingInitiatorFieldsFor) {
                return this.pendingInitiatorFields;
            }
            return [];
        },
        safariItpAllowed() {
            return isProxyEnabledDomain(this.domainList, this.tagDomain);
        },
        /** Image and redirect tags are a bare URL; everything else is a script wrapper. */
        emitsScript() {
            const tagType = this.tagTemplate.tag_type || '';
            return tagType.indexOf('.gif') === -1 && tagType !== 'r';
        },
        /**
         * Safari detection has to run in the browser, so it needs the script wrapper.
         * A bare URL cannot pick a domain per browser, so asking for the two values
         * on an image or redirect tag would collect input we then discard.
         */
        safariItpApplies() {
            return this.safariItpAllowed && this.emitsScript;
        },
        /**
         * Both values are required once Safari ITP applies. Until they are in, the tag
         * would be generated against the aUT domain only - showing that is worse than
         * showing nothing, because it is copyable and silently missing Safari routing.
         */
        safariItpIncomplete() {
            if (!this.safariItpApplies) return false;
            return !String(this.safariItpClientDomain || '').trim()
                || !String(this.safariItpPathPrefix || '').trim();
        },
        eventTypeOptions() {
            return tag_event_types;
        },
        initiatorOptions() {
            var options = [{ label: "None", value: "" }];
            this.$store.getters["aut/initiatorOptions"].map((initiator)=>{
                    return options.push({ label: initiator.label, value:initiator.value })
            })
            return options;
        },
        tagTypeOptions() {
            var options = [];
            options.push(
                { label: "a.gif", value: "a.gif" },
                { label: "c.gif", value: "c.gif" },
                { label: "r", value: "r" },

                { label: "s.js", value: "s.js" },
                { label: "c.js", value: "c.js" },
                { label: "cs.js", value: "cs.js" },

                { label: "t.dhj", value: "t.dhj" },
                { label: "tc.dhj", value: "tc.dhj" },
                { label: "ts.dhj", value: "ts.dhj" },
                { label: "tcs.dhj", value: "tcs.dhj" }
            );
            return options;
        },
        loggingModeOptions() {
            var options = [];
            options.push(
                { label: "A", value: "a" },
                { label: "B", value: "b" },
                { label: "C", value: "c" },
                { label: "D", value: "d" },
                { label: "E", value: "e" },
                { label: "F", value: "f" },
                { label: "G", value: "g" },
                { label: "H", value: "h" },
                { label: "I", value: "i" },
                { label: "J", value: "j" },
                { label: "K", value: "k" },
                { label: "L", value: "l" },
                { label: "M", value: "m" }
            );
            return options;
        },
        deliveryOptions() {
            var options = [
                { label: "Atomic", value: "atomic" },
                { label: "Container", value: "container" },
            ];
            return options;
        },
        atomicOptions() {
            var options = [
                { label: "Image", value: "img" },
                { label: "JavaScript", value: "js" },
                { label: "Redirect", value: "r" },
            ];
            return options;
        },
        logicOptions() {
            var options = [];

            if (this.deliveryType != "atomic" || this.atomicType != "js")
                options.push({ label: "None", value: "" });

            options.push({ label: "Cookie", value: "c" });

            if (this.deliveryType != "atomic" || this.atomicType != "img")
                options.push(
                    { label: "Stat", value: "s" },
                    { label: "Cookie and Stat", value: "cs" }
                );

            return options;
        },
        domainOptions() {
            let domainOptions = [];
            if (this.domainList) {
                this.domainList.map((domainObj) => {
                    if (domainObj.domains && domainObj.domains.items) {
                        domainObj.domains.items.map((domainItem) => {
                            domainOptions.push({
                                label: domainItem.name,
                                value: domainItem.name,
                            });
                        });
                    }
                });
            }
            return domainOptions;
        },
        classOptions() {
            let clsOptions = [{ label: "None", value: "" }];
            this.$store.state.aut.autClientData.classes?.items.map((clsObj) => {
                clsOptions.push({ label: clsObj.cls, value: clsObj.cls });
            });
            return clsOptions;
        },
        logDeliveryOptions() {
            var options = [
                { label: "None", value: "" },
                { label: "Batch", value: "b" },
                { label: "Streaming", value: "s" },
            ];
            return options;
        },
        logSizeOptions() {
            var options = [
                { label: "Base", value: "b" },
                { label: "Extended", value: "e" },
            ];
            return options;
        },
        logIPTypeOptions() {
            var options = [
                { label: "Hashed IP", value: "h" },
                { label: "Plain IP", value: "i" },
                { label: "No IP", value: "n" },
            ];
            return options;
        },
        userDefinedFieldOptions() {
            var options = [];
            if (this.tagTemplate.user_defined_fields) {
                for (const key in USER_DEFINED_FIELD_KEYS) {
                    var exists = false;
                    for (let i = 0; i < this.tagTemplate.user_defined_fields.length; i++) {
                        if (this.tagTemplate.user_defined_fields[i].parameter == key) {
                            exists = true;
                        }
                    }
                    if (!exists)
                        options.push({ label: USER_DEFINED_FIELD_KEYS[key], value: key })
                }
            }
            return options;
        },
        loggingMode() {
            let logMode = this.logDelivery + this.logSize + this.logIPType;
            for (const key in LOG_KEYS) {
                if (LOG_KEYS[key] == logMode) return key;
            }
            return "a";
        },
        generatedCode() {
            let template;
            // System values and the redirect url are fully escaped; initiator and
            // user defined field values escape only URL-breaking characters.
            let tagParams = {};
            const system = (k, v) => { tagParams[k] = { value: String(v), encode: escapeTagComponent }; };
            const fieldParam = (k, v) => { tagParams[k] = { value: String(v), encode: encodeFieldValue }; };

            if (this.tagClass) system("cls", this.tagClass);
            if (this.tagTemplate.event_type)
                system("aqet", this.tagTemplate.event_type);
            if (this.tagTemplate.sub_event_type_1)
                system("aqet_l1", this.tagTemplate.sub_event_type_1);
            if (this.tagTemplate.sub_event_type_2)
                system("aqet_l2", this.tagTemplate.sub_event_type_2);
            if (this.tagTemplate.measurement_tag) system("aq_m", 1);

            // find initiator values
            for (const field of this.initiatorFields) {
                if (this.omittedFields[field.name]) continue;
                fieldParam(field.parameter, field.input);
            }

            // find user defined fields
            for (const field of this.tagTemplate.user_defined_fields || []) {
                fieldParam(field.parameter, field.input);
            }

            //for redirect tag
            if (this.tagTemplate.tag_type == 'r' && this.redirectTarget) {
                system("ru", this.redirectTarget);
            }

            if (!this.emitsScript) {
                // URL TEMPLATE - USE FOR ATOMIC IMG TAGS
                const urlParams = Object.keys(tagParams)
                    .map((k) => `${encodeTagParamName(k)}=${tagParams[k].encode(tagParams[k].value)}`)
                    .join("&");
                template = `https://${this.tagDomainValue}/1/${this.tagTemplate.logging_mode}/${this.tagTemplate.tag_type}?${urlParams}`;
            } else {
                // WRAPPER TEMPLATE - ALL OTHER TAGS
                // Safari ITP: for a proxy-enabled domain the tag carries both hosts and
                // picks at runtime. Every `itp.*` piece is inert for other domains,
                // which have no client website domain, leaving the snippet unchanged.
                const itp = safariItpTagParts({
                    autDomain: this.tagDomainValue,
                    clientWebsiteDomain: this.safariItpClientDomain,
                    pathPrefix: this.safariItpPathPrefix,
                });
                template = `<script title="pxsnpt">\n`;
                if (itp.active) {
                    template += `  ${itp.detectionStatement}\n`;
                }
                template += `\
  var ${this.label}Data = {\n\
    cdmn : ${itp.cdmnExpr},\n\
    lm : '${this.tagTemplate.logging_mode}',\n\
    tt : '${this.tagTemplate.tag_type}'${itp.active ? `,\n    pathPrefix : ${itp.pathPrefixValueExpr}` : ''}\n\
  };\n\
  !function(a){\n`;
                for (const key in tagParams) {
                    const { value: raw, encode } = tagParams[key];
                    const value = raw.startsWith("!var:")
                        ? raw.slice(5)
                        : `'${encode(raw)}'`;
                    template += `    a["${encodeTagParamName(key)}"] = ${value};\n`;
                }
                template +=
                    `  }(${this.label}Data);\n\
  function _pxTagInject(p,d,w,l){\n\
    var o,k=[],t=p.tt.slice(-1),x={${itp.excludeKeys}},y={cid:1,cls:1,dmn:1,pubid:1,evid:1,aq_m:1};p.dmn=(p.dmn||(w.top[l]===w[l]?''+w[l]:d.referrer).split('/')[2]).split(':')[0];for(o in p){if(y[o]||((t!='j'||p.aq_m)&&!x[o])){k.push(o+"="+p[o]);};};var s=d.createElement(t=='f'?'img':'script');s.id=s.title='pxscrpt';s.async=s.defer=!0;s.src='//'+${itp.srcHostExpr}+'/1/'+p.lm+'/'+p.tt+'?'+k.join("&");d.body.appendChild(s);\n\
}_pxTagInject(${this.label}Data,document,window,'location');\n\
</` + `script>`;
            }

            return template;
        },
        tagDomainValue(){
            return this.tagDomain === ""?"{{hostname}}":this.tagDomain
        },
        showRecommended(){
            return this.tagTemplate.public
        },
        initiator(){
            return this.$store.getters["aut/initiatorOptions"].find((initiator)=> initiator.value == this.tagTemplate.initiator)
        }
    },
    beforeMount() {
        this.$store.dispatch('aut/fetchAutClientData', this.cid)
        this.setInitialOptions();
        this.getDomainList();
        this.$store.dispatch("aut/fetchAllInitiators");
    },
    methods: {
        ...mapActions({
            getDomainList: "aut/getDomainLists",
            fetchInitiatorFields: "aut/fetchAllInitiatorFields",
            readTagTemplate: "aut/readTagTemplate",
            updateTagTemplate: "aut/updateTagTemplate",
            deleteTagTemplate: "aut/deleteTagTemplate",
            showModal: "showModal",
        }),
        clearSafariItpIfUnused() {
            if (this.safariItpApplies) return;
            this.safariItpClientDomain = "";
            this.safariItpPathPrefix = "";
        },
        setInitialOptions() {
            if (!this.tagTemplate.notes)
                this.tagTemplate.notes = ""
            if (!this.tagTemplate.user_defined_fields)
                this.tagTemplate.user_defined_fields = []
            if (!this.tagTemplate.metadata)
                this.tagTemplate.metadata = {}
            this.resolvedInitiator = this.tagTemplate.initiator || "";
            this.getInitiatorFields();

            if (this.tagTemplate.logging_mode in LOG_KEYS) {
                const logMode = LOG_KEYS[this.tagTemplate.logging_mode];
                this.logDelivery = logMode[0];
                this.logSize = logMode[1];
                this.logIPType = logMode[2];
            }

            let deliveryType, logicType, atomicType;
            
            deliveryType = (this.tagTemplate.tag_type.indexOf("dhj") !== -1) ? "container" : "atomic";
            
            if (this.tagTemplate.tag_type.indexOf("cs") !== -1)
                logicType = "cs";
            else if (this.tagTemplate.tag_type.indexOf("c") !== -1)
                logicType = "c";
            else if (this.tagTemplate.tag_type.indexOf("s") !== -1)
                logicType = "s";
            else logicType = "";

            if (this.tagTemplate.tag_type.indexOf(".js") !== -1)
                atomicType = "js";
            else if (this.tagTemplate.tag_type.indexOf("r") !== -1)
                atomicType =  "r";
            else atomicType = "img";

            this.deliveryType = deliveryType;
            this.atomicType = atomicType;
            this.logicType = logicType;
            this.onEventChange(this.tagTemplate.event_type)
            if(this.tagTemplate.sub_event_type_1){
                this.onSubEvent1Change(this.tagTemplate.sub_event_type_1)
            }

        },
        async getInitiatorFields() {
            const initiator = this.tagTemplate.initiator;
            if (!initiator || initiator === this.resolvedInitiator) return;
            try {
                const fields = await this.fetchInitiatorFields(initiator);
                if (this.tagTemplate.initiator !== initiator) return;
                this.pendingInitiatorFields = fields;
                this.pendingInitiatorFieldsFor = initiator;
            } catch (error) {
                return;
            }
        },
        initiatorFieldMeta(name) {
            return (this.tagTemplate.metadata || {})[name] || {};
        },
        writeInitiatorFieldMeta(name, meta) {
            this.tagTemplate.metadata = {
                ...(this.tagTemplate.metadata || {}),
                [name]: meta,
            };
        },
        userDefinedMetaKey(index) {
            return "udf:" + index;
        },
        metaText(meta) {
            return Object.keys(meta || {}).length ? JSON.stringify(meta) : "";
        },
        parseMeta(text) {
            const trimmed = (text || "").trim();
            if (!trimmed) return {};
            const meta = JSON.parse(trimmed);
            if (meta === null || typeof meta !== "object" || Array.isArray(meta)) {
                throw new Error("must be a JSON object");
            }
            if (Object.keys(meta).some((key) => !key.trim())) {
                throw new Error("keys must not be empty");
            }
            return meta;
        },
        onInitiatorFieldMetaInput(field, text) {
            this.metaDrafts = { ...this.metaDrafts, [field.name]: text };
            try {
                this.writeInitiatorFieldMeta(field.name, this.parseMeta(text));
                this.clearMetaError(field.name);
            } catch (error) {
                this.setMetaError(field.name, error.message);
            }
        },
        onUserDefinedFieldMetaInput(index, text) {
            const key = this.userDefinedMetaKey(index);
            this.metaDrafts = { ...this.metaDrafts, [key]: text };
            const field = this.tagTemplate.user_defined_fields[index];
            try {
                field.meta_data = this.parseMeta(text);
                this.clearMetaError(key);
            } catch (error) {
                this.setMetaError(key, error.message);
            }
        },
        setMetaError(key, message) {
            this.metaErrors = { ...this.metaErrors, [key]: "Invalid metadata: " + message };
            this.$emit("metaValid", false);
        },
        clearMetaError(key) {
            const errors = { ...this.metaErrors };
            delete errors[key];
            this.metaErrors = errors;
            this.$emit("metaValid", Object.keys(errors).length === 0);
        },
        removeUserDefinedField(index) {
            this.tagTemplate.user_defined_fields.splice(index, 1);
        },
        copyMinified() {
            if (!this.tagDomain) {
                const options = {
                    message: "You must select a Domain.",
                    type: "error",
                };
                this.$store.dispatch("addToast", options);
            } else {
                let code = this.generatedCode;
                code = code.replaceAll("\n", "");
                code = code.replaceAll("  ", "");
                navigator.clipboard.writeText(code);
                const options = {
                    message: "Code copied to clipboard",
                    type: "success",
                };
                this.$store.dispatch("addToast", options);
            }
        },
        onCustomAdd(){
            this.userDefinedFieldAddon="Custom"
        },
        updateTagTypeField() {
            let tagType;
            if (this.deliveryType == "container") {
                tagType = "t" + this.logicType + ".dhj";
            } else {
                if (this.atomicType == "img") {
                    tagType = this.logicType == "c" ? "c.gif" : "a.gif";
                } else if (this.atomicType == "js") {
                    tagType = this.logicType + ".js";
                } else {
                    tagType = "r";
                }
            }
            this.tagTemplate.tag_type = tagType
        },
        onEventChange(newVal,oldValue){
            let event_index= tag_event_types.findIndex((event)=> event.value==newVal)
            this.subEvent1Options=[]
            this.subEvent2Options=[]
            if(oldValue){
                this.tagTemplate.sub_event_type_1='';
                this.tagTemplate.sub_event_type_2='';
            }
            if(event_index!=-1 && tag_event_types[event_index].sub_events){
                this.subEvent1Options=tag_event_types[event_index].sub_events;
            }
        },
        onSubEvent1Change(newVal){
            this.subEvent2Options=[]
                if(this.subEvent1Options.length>0){
                    let event_index= this.subEvent1Options.findIndex((event)=> event.value==newVal)
                    if(event_index!=-1 && this.subEvent1Options[event_index].sub_events){
                        this.subEvent2Options=this.subEvent1Options[event_index].sub_events
                    }
                }
        }
    }
};
</script>

<style scoped>
code {
    color: #dcdcdc;
    white-space: pre-wrap;
}
.checkbox-center{
    display: flex;
    align-items: center;
}
</style>